import * as React from 'react';

import { Preloader } from '@cian/preloader-component';

import * as styles from './SearchPreloader.css';

export function SearchPreloader() {
  return (
    <div data-mark="SearchPreloader" className={styles['preloader_overlay']}>
        <Preloader size={50} preloaderStyle={styles['preloader']} />
    </div>
  );
}
